import {http} from "@/axios";

const VENUES_RESOURCE = '/search-venue';
const VENUE_PROFILE_RESOURCE = '/venue-profile';

export default {
  list: (page = 1, title = '') => http.get(`${VENUES_RESOURCE}${title ? `/${title}` : ''}?page=${page}`),
  venueProfile: (id) => http.get(`${VENUE_PROFILE_RESOURCE}/${id}`),
};
